export const ru = {
  shell: {
    menu: 'Меню',
    exit: 'Выход',
    profile: 'Профиль пользователя',
    personalAccount: 'Личный кабинет',
    developedBy: 'Разработано'
  },
  authentication: {
    authentication: 'Авторизация',
    registration: 'Регистрация'
  },
  campaigns: {
    campaigns: 'Рассылки',
    dailyCampaigns: 'Ежедневные рассылки',
    daily: 'Ежедневные',
    dailyLabel: '└─Ежедневные',
    campaign: 'Рассылка',
    newCampaign: 'Новая рассылка',
    campaignsArchive: 'Архив рассылкок',
    createCampaign: 'Создать рассылку',
    putCampaignsName: 'Введите название рассылки',
    ringing: 'Прозвон',
    report: 'Отчёт',
    unprocessed: 'Необработанные',
    monitoring: 'Мониторинг',
    cost: 'Стоимость',
    toArchive: 'В архив',
    loadBase: 'Загрузка базы',
    putBaseFromClipboard: 'Вставьте базу из буфера обмена',
    deleteFailedCalls: 'Удалить несостоявшиеся звонки',
    reportTexts: {
      createReport: 'Создать отчёт',
      reportIsBeingGeneratedNow: 'Отчёт генерируется',
      createReportError: 'Ошибка создания отчёта'
    },
    states: {
      started: 'Запущена',
      readyToRun: 'Готова к запуску',
      preparing: 'В разработке',
      ready: 'Подготовлена',
      // started: 'Прозвон идёт',
      finished: 'Завершена',
      paused: 'Остановлена',
      canceled: 'Отменена'
    },
    campaignParams: {
      campaignsParameters: 'Параметры рассылки',
      callDate: 'Дата прозвона',
      putCallDate: 'Введите дату',
      timezone: 'Часовой пояс',
      callTime: 'Время прозвона',

      numberOfAttemptsToGetThrough: 'Количество попыток дозвониться',
      intervalBetweenRepeatedCalls: 'Интервал между повторными звонками',
      openScenario: 'Открыть сценарий',
      scenarioIsReady: 'Сценарий подготовлен',
      scenarioIsNotReady: 'Сценарий неподготовлен',

      base: 'База',
      viewBase: 'Просмотреть базу',
      removeBase: 'Удалить базу',
      numbers: 'номера',
      uploadedNumbers: 'Загружено номеров',
      reportByTestCalls: 'Отчёт по тестовым звонкам',

      callResult: 'Результат обзвона',
      callsMonitoring: 'Мониторинг рассылки'
    },
    additionalParameters: {
      additionalParameters: 'Дополнительные параметры'
    },
    quotas: {
      quotas: 'Квоты',
      noLimit: 'Без ограничений',
      addQuota: 'Добавить квоту'
    }
  },
  testCall: {
    testCall: 'Тестовый звонок',
    callToNumber: 'Позвонить на номер',
    call: 'Позвонить',
    putNumber: 'Введите номер',
    viewTestResults: 'Просмотреть результаты тестов',
    testCallParameters: 'Параметры тестового звонка',
    callToPhone: 'на телефон',
    calInBrowser: 'в браузере',
    toPhoneNote:
      'для звонка на телефон должна быть создана рассылка с настройками для исходящих вызовов',
    inBrowserNote:
      'для звонка в браузере необходимо разрешить использование микрофона и перезагрузить страницу'
  },
  scenarios: {
    scenarios: 'Сценарии',
    scenario: 'Сценарий',
    createScenario: 'Создать сценарий',
    newScenario: 'Новый сценарий',
    scenarioName: 'Название сценария',
    putScenarioName: 'Введите название сценария',
    prepared: 'Подготовлен',
    notPrepared: 'Не подготовлен',
    scenarioTemplate: 'Шаблон сценария',
    chooseScenarioTemplate: 'Выберите шаблон сценария',
    konstruktor: {
      // toolButtons: {
      //   testCall: 'Тестовый звонок',
      //   callToNumber: 'Позвонить на номер'
      // },
      commonParams: {
        hideArrows: 'Скрыть стрелки'
      },
      canvas: {
        add: {
          robotAnswer: 'ответ робота',
          recognition: 'распознование',
          redirectToOperator: 'перевод на оператора',
          sendSMS: 'Отправить смс',
          sendHttpRequest: 'Отправить http запрос'
        },
        answer: {
          answer: 'Ответ',
          startOfTalk: 'Начало разговора',
          stateQuestion: 'Вопрос состояния',
          silence: 'Молчание',
          illegibly: 'Неразборчиво',
          approve: 'Одобрение',
          deny: 'Отрицание',
          custom: 'Индивидуальное',
          anotherAnswer: 'Другой ответ',
          foStatusValueUse: 'Для значения состояния использовать',
          transcription: 'Транскрибация',
          indicate: 'Указать',
          stateValue: 'Значение состояние',
          windowSizes: {
            smallSize: 'Маленький размер',
            mediumSize: 'Средний размер',
            maxSize: 'Максимальный размер'
          },
          synonyms: {
            addForAllWithSameTitle: 'Добавить для всех с таким же названием',
            addWord: 'Добавьте слово'
          },
          initAudio: {
            fromText: 'Из текста',
            toPutUrl: 'Ввести урл',
            putUrl: 'Введите урл',
            toAddUrl: 'Добавить урл',
            toRemoveUrl: 'Удалить урл',

            toUploadFromFile: 'загрузить из файла',
            toRemoveAll: 'Удалить всё',

            toAddParameter: 'Добавить параметр',
            putParameterName: 'Добавьте название параметра',
            addParameter: 'Добавьте параметр',
            toRemoveParameter: 'Удалить параметр',
            speed: 'Скорость',
            generateAudio: 'Сгенерировать',

            text: 'Текст',

            Your_browser_does_not_support_html5_audio_Try_chrome:
              'Ваш браузер не поддерживает html5 audio. Попробуйте chrome.'
          },
          audioConfig: 'Настройки аудио',
          sipSubUrl: 'Сип адрес',
          sms: {
            gateway: 'Шлюз',
            sender: 'Отправитель',
            messageText: 'Текст сообщения'
          },
          httpRequest: {
            params: 'Параметры',
            headers: 'Заголовки',
            body: 'Тело'
          }
        },
        recognition: {
          recognitionDriver: 'Драйвер распознавания',
          driver: 'Драйвер'
        }
      }
    },
    removeScenario: 'Удалить сценарий'
  },
  billing: {
    billing: 'Лицевой счёт',
    summaryLabel: '└─Аналитика затрат',
    detailsLabel: '└─Детализации',
    notificationsLabel: '└─Уведомления'

  },
  users: {
    users: 'Пользователи',
    user: 'Пользователь',
    newUser: 'Новый пользователь',
    userData: 'Данные пользователя'
  },
  callTasks: {
    testCallsByCampaign: 'Тестовые звонки по рассылке',
    phone: 'Телефон',
    state: 'Состояние',
    phoneNumber: 'Номер телефона',
    byCampaign: 'по рассылке',
    states: {
      failed: 'Недозвон',
      dialing: 'Вызов',
      ongoing: 'Идет разговор',
      performed: 'Выполнена',
      postponed: 'Отложена',
      ready: 'В очереди',
      telephony_error_suspend: 'Отложена',
      canceled: 'Отменена'
    }
  },
  permissions: {
    permissions: 'Настройки прав'
  },
  appConfig: {
    appConfig: 'Настройки приложения'
  },
  common: {
    default: 'По умолчанию',
    yes: 'Да',
    no: 'Нет',
    timeInterval: {
      from: 'С',
      to: 'До'
    },
    search: 'Поиск',
    title: 'Название',
    client: 'Клиент',
    template: 'Шаблон',
    readiness: 'Готовность',
    state: 'Статус',
    creationDate: 'Дата создания',
    up: 'наверх',
    settings: 'Настройки',
    action: 'Действие',
    actions: {
      add: 'Добавить',
      delete: 'Удалить',
      save: 'Сохранить',
      cancel: 'Отмена',
      close: 'Закрыть',
      connect: 'Соединить',
      run: 'Запустить',
      stop: 'Остановить',
      copy: 'Копировать',
      load: 'Загрузить',
      loadFromFile: 'Загрузить из файла',
      create: 'Создать',
      reCreate: 'Пересоздать',
      export: 'Экспортировать',
      import: 'Импортировать'
    },
    key: 'Ключ',
    parameter: 'Параметр',
    value: 'Значение',
    language: 'Язык',
    voice: 'Голос',
    time: {
      minutes: 'минуты',
      seconds: 'секунды'
    },
    date: {
      days: {
        longhand: {
          sunday: 'Воскресенье',
          monday: 'Понедельник',
          tuesday: 'Вторник',
          wednesday: 'Среда',
          thursday: 'Четверг',
          friday: 'Пятница',
          saturday: 'Суббота'
        },
        shorthand: {
          sunday: 'Вс',
          monday: 'Пн',
          tuesday: 'Вт',
          wednesday: 'Ср',
          thursday: 'Чт',
          friday: 'Пт',
          saturday: 'Сб'
        }
      },
      months: {
        January: 'Январь',
        February: 'Февраль',
        March: 'Март',
        April: 'Апрель',
        May: 'Май',
        June: 'Июнь',
        July: 'Июль',
        August: 'Август',
        September: 'Сентябрь',
        October: 'Октябрь',
        November: 'Ноябрь',
        December: 'Декабрь'
      }
    },
    results: 'Результаты',
    recognitionLogs: 'Логи распознавания',
    information: 'Информация'
  },
  paging: {
    first: 'Первая',
    previous: 'Предыдущая',
    next: 'Следующая',
    last: 'Последняя'
  },
  errors: {
    downloadError: 'Ошибка скачивания'
  },
  notifications: {
    notification: 'Уведомление',
    toAddRobotAnswerPleaseRemoveRedirectToOperator:
      'Чтобы добавить ответ, удалите перевод на оператора',
    toAddRedirectToOperatorPleaseRemoveAllRobotAnswers:
      'Чтобы добавить перевод на оператора, удалите все последующие ответы',
    thereIsAlreadyHasARedirectToOperator: 'Уже есть перевод на оператора',
    errorLoadApplicationConfig: 'Ошибка загрузки параметров приложения',
    errorLoadAudio: 'Ошибка загрузки аудио',
    beforeGenerateAudioYouShouldSaveScenario:
      'Перед генерацией аудио необходимо сохранить сценарий',
    beforeUploadFileYouShouldSaveScenario:
      'Перед загрузкой файла необходимо сохранить сценарий',
    beforeLoadAudioYouShouldSaveScenario:
      'Перед загрузкой аудио необходимо сохранить сценарий',
    campaign: {
      campaignIsReady: 'Рассылка подготовлена',
      errorStartCampaign: 'Ошибка запуска рассылки',
      campaignStopped: 'Рассылка остановлена',
      errorStopCampaign: 'Ошибка остановки рассылки',
      report: {
        errorLoadReport: 'Ошибка загрузки отчета'
      },
      errorDeletePhoneBase: 'Ошибка удаления телефонной базы',
      baseRemoved: 'База удалена'
    },
    scenario: {
      scenarioHasBeenRemoved: 'Сценарий удален',
      errorRemoveScenario: 'Ошибка удаления сценария',
      errorToGetUserStatus: 'Ошибка получения статуса пользователя',
      errorLoadScenarioList: 'Ошибка загрузки списка сценариев',
      errorLoadScenario: 'Ошибка загрузки сценария',

      scenarioSaved: 'Сценарий сохранён',
      errorSaveScenario: 'Ошибка сохранения сценария'
    },
    testCall: {
      testCallActivated: 'Тестовый звонок активирован',
      errorCreatingTestCall: 'Ошибка создания тестового звонка',
      testCallNumberSaved: 'Номер тестового звонка сохранен',
      saveCampaignBeforeTestCall: 'Перед тестом необходимо сохранить рассылку'
    },
    callTasks: {
      errorLoadTestCallsPhoneNumbers:
        'Ошибка загрузки тестовых телефонных номеров'
    }
  }
}



// WEBPACK FOOTER //
// ./client/translations/ru.js